<div class="min-h-screen flex flex-col">
    <pci-header (trayStateChanged)="onTrayStateChanged($event)"></pci-header>
    <main
        id="main-content"
        tabindex="-1"
        class="lg:block flex-1 mt-[108px] lg:mt-[134px] lg:h-auto"
        [ngClass]="{ hidden: mobileTrayOpened }"
    >
        <router-outlet />
    </main>
    <pci-footer class="lg:block" [ngClass]="{ hidden: mobileTrayOpened }"></pci-footer>
</div>
